import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useTwoFa } from '@libs/hooks';
import TwoFaAuth from '../two-fa-auth/TwoFaAuth';
import { AuthWrapper } from './styles';
export const TwoFactorAuth = ({ type, loading, className, shouldLogin = true, shouldSendSms = true, shouldSendEmail = true, incorrectCodeErrMessage, onAuthFinish, onComplete, onResend, ...rest }) => {
    const { handleTwoFaLogin, sendCode, loading: twoFaLoading, isCodeInvalid, } = useTwoFa(type, onComplete, onAuthFinish, shouldSendSms, shouldSendEmail, shouldLogin);
    const onCodeFill = (type, code) => {
        if (shouldLogin) {
            handleTwoFaLogin(type, code);
            return;
        }
        onComplete?.(type, code);
    };
    const handleResendCode = useCallback(() => {
        if (onResend) {
            onResend();
        }
        else {
            sendCode();
        }
    }, [onResend, sendCode]);
    return (_jsx(AuthWrapper, { className: className, children: _jsx(TwoFaAuth, { ...rest, type: type, loading: loading || twoFaLoading, onResend: handleResendCode, onComplete: onCodeFill, errorMessage: isCodeInvalid ? incorrectCodeErrMessage : '' }) }));
};
//# sourceMappingURL=TwoFactorAuth.js.map